import Reveal from "reveal.js"
Reveal.initialize({
    slideNumber: true,
    history: true,
    autoSlide: 1450,
})